<template>

    <div class="row text-start">
        <div class="col-lg-5 checkout-content" style="min-height:300px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
            <h5 style="color:black;margin-left:15px;">
                Field Inspections &amp Walkthroughs
            </h5>

            <div class="text-start text-muted fw-bold small">Pricing:</div>
            <div style="font-size:12px;" class="">
                <table class="mt-2" style="font-size: 10px; font-weight: bold; width: 100%; margin-left: 15px;">
                    <tr>
                        <td>Maximum Inspection Duration:</td>
                        <td class="fw-bold" style="color:limegreen">{{FieldInspectionConfig.inspectionDurationMinutes}} minutes</td>
                    </tr>
                    <tr class="fw-light" style="padding:10px;">
                        <td colspan="2" style="padding-top:10px;padding-bottom:10px;" class="mt-2">Pricing is notice time dependent.</td>
                    </tr>
                    <tr>
                        <td class="">Less than {{FieldInspectionConfig.minHoursNotice}} hour notice:</td>
                        <td class="fw-bold" style="color:red">Not Available</td>
                    </tr>
                    <tr>
                        <td>{{FieldInspectionConfig.minHoursNotice}} to {{FieldInspectionConfig.shortNoticeHourThreshold}} hour notice:</td>
                        <td class="fw-bold" style="color:limegreen">${{FieldInspectionConfig.shortNoticeFee.toFixed(2)}}</td>
                    </tr>
                    <tr>
                        <td>More than {{FieldInspectionConfig.shortNoticeHourThreshold}} hour notice:</td>
                        <td class="fw-bold" style="color:limegreen">${{FieldInspectionConfig.basicFee.toFixed(2)}}</td>
                    </tr>
                </table>
            </div>

            <div class="">
                <img src="/images/FieldInspectionIcon.png" style="width:100%" />
            </div>
        </div>
        <div class="col-lg-7 p-0">

            <div class="position-relative text-center px-3" style="top:0px;">

                <div class="">
                    <div class="h3 text-muted fw-semibold text-capitalize">Location Information</div>
                    <!-- Input Card -->
                    <div class="fw-bold p-0 mb-1 mt-5" style="color:limegreen">&nbsp; Enter Full Location Address*</div>

                    <input autofocus v-model="Store.Checkout.Cart.StartAddress" type="text" class="form-control form-control-sm" id="fnAddress" placeholder="<enter full address>" aria-label="full address">
                    <div class="blink text-red fw-bold text-center mt-2" style="font-size:12px;" v-if="StartError">{{StartError}}</div>
                </div>
                <!-- End Input Card -->
                <div class="fw-bold p-0 mb-1 mt-3" style="color:limegreen">&nbsp; What type of location is this?</div>
                <select v-model="Store.Checkout.Cart.InspectionLocationType" class="form-control form-control-sm">

                    <option value="Residential">Residential</option>
                    <option value="Commercial">Commercial</option>
                    <option value="Industrial">Industrial</option>
                </select>
                <div class="blink text-red fw-bold text-center mt-2" style="font-size:12px;" v-if="LocationError">{{LocationError}}</div>

                <div v-if="Store.Checkout.Cart.InspectionLocationType == 'Residential'">
                    <div class="fw-bold p-0 mb-1 mt-3" style="color:limegreen">&nbsp; Is this location currently occupied?</div>
                    <select v-model="Store.Checkout.Cart.InspectionOccupiedType" class="form-control form-control-sm">
                        <option value="Occupied">Occupied</option>
                        <option value="Unoccupied">Unoccupied</option>
                    </select>
                    <div class="blink text-red fw-bold text-center mt-2" style="font-size:12px;" v-if="LocationSubTypeError">{{LocationSubTypeError}}</div>
                </div>

                <div>
                    <div class="fw-bold p-0 mb-1 mt-1 mt-3" style="color:limegreen">&nbsp; Choose your report format:</div>
                    <select v-model="Store.Checkout.Cart.InspectionReportType" class="form-control form-control-sm">
                        <option value="ChecklistOnly">Written Checklist/Report Only</option>
                        <option v-if="FieldInspectionConfig.reportHDPhotos" value="Photo">HD Photography</option>
                        <option v-if="FieldInspectionConfig.reportHDVideo" value="Video">HD Video</option>
                        <option v-if="FieldInspectionConfig.reportLiveStream" value="LiveStream">Live Streaming</option>
                    </select>
                </div>

                <div>
                    <div class="fw-bold p-0 mb-1 mt-1 mt-3" style="color:limegreen">&nbsp; In a few words, describe what we're inspecting*</div>

                    <div class="row mb-1">
                        <div class="col-12">
                            <textarea placeholder="Enter a general description and any special instructions that will help us carry out your inspection/walkthrough." style="resize:vertical;max-height:150px;" maxlength="1024" rows="5" v-model="Store.Checkout.Cart.InspectionDesc" class="form-control form-control-sm shadow-sm" />
                            <div class="blink text-red fw-bold text-center mt-2" style="font-size:12px;" v-if="InspectionEDescError">{{InspectionEDescError}}</div>
                        </div>
                    </div>

                </div>

                <div>
                    <div class="fw-bold p-0 mb-1 mt-1 mt-3" style="color:limegreen">&nbsp; Optionally, enter up to {{Store.Checkout.Cart.InspectionCheckList.length}} specific items you want us to inspect:</div>
                    <div v-for="(item, idx) in Store.Checkout.Cart.InspectionCheckList">
                        <div class="row mb-1">
                            <div class="col-1">
                                <label>{{idx+1}}.</label>
                            </div>
                            <div class="col-11">
                                <input maxlength="256" type="text" v-model="item.val" class="form-control form-control-sm shadow-sm" />
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    </div>
    <div data-bs-keyboard="false" data-bs-backdrop="static" style="z-index:300;" id="MessageModalInspectionLoc" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="margin-bottom: 150px;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="" style="">
                        <h4 class="modal-title h4" style="margin: 0 auto !important;">Confirm Field Inspection Location</h4>
                    </div>
                </div>
                <div class="modal-body">
                    <hr style="margin-bottom:5px;margin-top:5px;" />
                    <div class="row mb-0" style="padding-top:0;">
                        <div class="col-md-12 text-center mt-3">
                            <span class="text-muted fw-bold">Service Address:</span><br /><span class="fw-bold" style="color:limegreen;">{{Store.Checkout.Cart.StartAddress}}</span>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-md-12">
                            <div class="border-1 shadow-sm" style="border: 1px solid lightgray;">

                                <iframe style="border:0;width:100%;height:400px"
                                        loading="lazy"
                                        allowfullscreen
                                        referrerpolicy="no-referrer-when-downgrade"
                                        :src="PlaceMapSrc">
                                </iframe>

                            </div>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-6" style="padding-right:0;">
                            <div class="d-grid gap-0">
                                <button type="button" @click="OnMakeLocationChanges" class="btn btn-sm btn-dark shadow btn-block" style="border-radius:0;">Make Changes</button>
                            </div>
                        </div>
                        <div class="col-6" style="padding-left:0;">
                            <div class="d-grid gap-0">
                                <button type="button" @click="OnFieldInspectionLocationOK" class="btn btn-sm btn-primary shadow btn-block btn-pointer" style="border-radius:0;">Looks Good</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'VenueSelectFieldNotary',
        components: {
        },
        watch:{
             'Store.Checkout.Cart.InspectionLocationType': function (newVal, oldVal) {
                 this.ClearInspectionErrors();   
             },
             'Store.Checkout.Cart.InspectionOccupiedType': function (newVal, oldVal) {
                 this.ClearInspectionErrors();
             },
             'Store.Checkout.Cart.InspectionDesc': function (newVal, oldVal) {
                 this.ClearInspectionErrors();
            },
            'Store.Checkout.Cart.InspectionCheckList': function (newVal, oldVal) {
                
            },
            
        },
        props: {
        },
        data() {
            return {
                Store: {},
                LocationError: '',
                StartError: '',
                LocationSubTypeError: '',
                InspectionEDescError: '',
                PlaceMapSrc:''
            };
        },
        methods:
        {
            OnStepActivated: async function(){
                if(this.Store.Checkout.Cart.CurrentStep == 1){
                    //init
                }
            },
            ClearInspectionErrors: function () {
                this.InspectionEDescError = '';
                this.LocationError = '';
                this.LocationSubTypeError = '';
            },
            OnCmdNext: async function () {
                if(this.Store.Checkout.Cart.CurrentStep != 1){
                    return;
                }

                if (this.Store.Checkout.Cart.SelectedService == 'FieldInspection') {
                    if (!this.Store.Checkout.Cart.StartAddress) {
                        nextTick().then(() => {
                            this.StartError = "Address can't be blank.";
                        });

                        toast.error("Address can't be blank.");
                        window.scrollTo(0, 0);
                        return;
                    }

                    var err = '';
                    if (this.Store.Checkout.Cart.InspectionLocationType == 'Residential') {
                        if (!this.FieldInspectionConfig.offerResidentialOccupied && !this.FieldInspectionConfig.offerResidentialUnoccupied) {
                            err = "Field inspections for residential locations are not offered at this time.";
                            this.LocationError = err;
                        }
                        else if (this.Store.Checkout.Cart.InspectionOccupiedType == 'Occupied' && !this.FieldInspectionConfig.offerResidentialOccupied) {
                            err = "Field Inspections for occupied residential locations are not offered at this time.";
                            this.LocationSubTypeError = err;
                        }
                        else if (this.Store.Checkout.Cart.InspectionOccupiedType == 'Unoccupied' && !this.FieldInspectionConfig.offerResidentialUnoccupied) {
                            err = "Field Inspections for unoccupied residential locations are not offered at this time.";
                            this.LocationSubTypeError = err;
                        }
                    }

                    else if (this.Store.Checkout.Cart.InspectionLocationType == 'Commercial' && !this.FieldInspectionConfig.offerCommercial) {
                        err = "Field inspections for commercial locations are not offered at this time.";
                        this.LocationError = err;
                    }

                    else if (this.Store.Checkout.Cart.InspectionLocationType == 'Industrial' && !this.FieldInspectionConfig.offerIndustrial) {
                        err = "Field inspections for industrial locations are not offered at this time.";
                        this.LocationError = err;
                    }

                    if (!this.Store.Checkout.Cart.InspectionDesc) {
                        err = "Inspection description can't be blank.";
                        this.InspectionEDescError = err;
                    }

                    if (err) {
                        toast.error("Please fix errors before moving on.");
                        window.scrollTo(0, 0);
                        return;
                    }

                    await this.ValidateAndDisplayAddressInspection(this.Store.Checkout.Cart.StartAddress);
                    return;
                }
            },
            ValidateAndDisplayAddressInspection: async function (start) {
                this.StartError = "";
                EventHub.$emit("WizLoading", true);


                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                var that = this;
                // ajax to server to get distance and cost estimate
                axios.postForm('/API/GetInspectionEstimate', { serviceAddress: start }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {

                    EventHub.$emit("WizLoading", false);

                    if (response.data.success) {

                        that.PlaceMapSrc = response.data.mapsrc;
                        var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalInspectionLoc');
                        if (modal) {
                            modal.show();
                        }
                    }
                    else {
                        that.StartError = response.data.msg;
                        toast.error("There was an error. " + response.data.msg);
                    }
                }).catch(function (error) {
                    EventHub.$emit("WizLoading", false);
                    toast.error("There was an error. Please refresh the page and try again.");
                });

            },
            OnFieldInspectionLocationOK: function () {
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalInspectionLoc');
                if (modal) {
                    modal.hide();
                }
                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
            },

            OnMakeLocationChanges: function () {
                var modal = bootstrap.Modal.getOrCreateInstance('#MessageModalInspectionLoc');
                if (modal) {
                    modal.hide();
                }
            },

        },
        computed:
        {
            FieldInspectionConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }
                return {};
            },
        },
        beforeMount: function () {

        },
        created: function () {
            this.Store = useEditorStore();
        },
        mounted: function () {
            this.Store.Checkout.NextButton.IsVisible = true;
            this.Store.Checkout.NextButton.Text = "Continue To Scheduling";
            this.Store.Checkout.NextButton.Icon = "bi-calendar-check";
            EventHub.$on('OnStepActivated', this.OnStepActivated);
            EventHub.$on('OnCmdNext', this.OnCmdNext);
        },
        beforeUnmount: function () {
            EventHub.$off('OnStepActivated', this.OnStepActivated);
            EventHub.$off('OnCmdNext', this.OnCmdNext);
        }
    }
</script>

<style>
  
</style>